export const BUTTON = 'BUTTON' as const;
export const MENU_ITEM = 'MENU_ITEM' as const;
export const BUTTON_ITEM_TEST_ID_SUFFIX = '.ui.button-item';
